import { DefaultItem, DestructureGetters } from "./interfaces";

export const destructureItem = <T>(
  item: T,
  getters: DestructureGetters<T>,
): DefaultItem<T> => {
  const { getId, getLabel, getSubsections } = getters;

  if (!("id" in item) && !getId) {
    throw new Error("SectionNavigationItemsMapper: getId prop is required!");
  }

  if (!("label" in item) && !getLabel) {
    throw new Error("SectionNavigationItemsMapper: getLabel prop is required!");
  }

  const maybeDefaultItem = item as unknown as DefaultItem<T>;

  return {
    id: maybeDefaultItem.id || (getId && getId(item)) || "",
    label: maybeDefaultItem.label || (getLabel && getLabel(item)) || "",
    subsections:
      maybeDefaultItem.subsections ||
      (getSubsections && getSubsections(item)) ||
      [],
  };
};

export const countMaxLevel = <T>(
  items: T[],
  getters: DestructureGetters<T>,
  level = 0,
): number => {
  return items.reduce((acc, item) => {
    const { subsections } = destructureItem(item, getters);

    if (!subsections) {
      return Math.max(acc, level);
    }

    return Math.max(acc, level, countMaxLevel(subsections, getters, level + 1));
  }, level);
};
